import TobbszorosKerdesTableService from 'app/admin/tobbszoroskerdes/service/TobbszorosKerdesTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'tobbszorosKerdesTable',
	text: 'Többszörös kérdés',
	textKey: 'question',
	service: TobbszorosKerdesTableService,
	icon: 'person',
	editFormState: item => `/tobbszoroskerdes/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'csorszam',
			propertyType: 'String',
			type: 'LIKE'
		},
		{
			propertyName: 'feladatCsoport',
			propertyType: 'Long',
			type: 'IN'
		},
		{
			propertyName: 'fejezet',
			propertyType: 'Long',
			type: 'IN'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'csorszam',
			text: 'Sorszám',
			textKey: 'csorszam',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
        {
			key: 'leirasPlaintext',
			text: 'Leírás',
			textKey: 'leirasPlaintext',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
        {
			key: 'magyarazatPlaintext',
			text: 'Magyarázat',
			textKey: 'magyarazatPlaintext',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function TobbszorosKerdesTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('tobbszorosKerdesTable', reducer('tobbszorosKerdesTable'))(TobbszorosKerdesTable);
